import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
//import { LoginApi, UserApi } from "../apiActions";
import { RootState } from "../store";
import { AdministrationIndexApi } from "../apiActions";
import { List } from '@mui/material';

export interface Search {
    titles: string[],
    reached_end: boolean,
}

export interface SearchResult {
    titles: string[],
    reached_end: boolean,
}

export interface SearchResultMetadata {
    title?: string
    href?: string
    url?: string
    table?: string
}

export interface SearchRequest {
    message: string,
    exclude_ids: string[],
    source_tables: string[]
}

export interface IndexRequest {
    index_name: string,
    skip: number,
}

interface SearchState {
    search: Search | null,
    isLoading: boolean,
    initial: boolean
}

export const initialState = {
    search: null,
    isLoading: false,
    initial: true,
} as SearchState


export const fetchSearch = createAsyncThunk("indexSearch/fetchSearch", async (body: IndexRequest) => {
    const response = await AdministrationIndexApi.get(body, {});
    return response.data;
})

const indexSlice = createSlice({
    name: 'indexSearch',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSearch.pending, (state, action) => {
                state.isLoading = true;
                state.search = null;
            })
            .addCase(fetchSearch.fulfilled, (state, action) => {
                state.isLoading = false;
                state.initial = false;
                state.search = action.payload
            })
            .addCase(fetchSearch.rejected, (state, action) => {
                state.isLoading = false;
                console.log("error while list:", action)
            })

    }
})

export const { } = indexSlice.actions;

export default indexSlice.reducer;
export const indexSelector = (state: RootState) => state.indexSearch;